import { render, staticRenderFns } from "./BannerDetails.vue?vue&type=template&id=17306714&scoped=true"
import script from "./BannerDetails.vue?vue&type=script&lang=ts"
export * from "./BannerDetails.vue?vue&type=script&lang=ts"
import style0 from "./BannerDetails.vue?vue&type=style&index=0&id=17306714&lang=scss"
import style1 from "./BannerDetails.vue?vue&type=style&index=1&id=17306714&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17306714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17306714')) {
      api.createRecord('17306714', component.options)
    } else {
      api.reload('17306714', component.options)
    }
    module.hot.accept("./BannerDetails.vue?vue&type=template&id=17306714&scoped=true", function () {
      api.rerender('17306714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banner/components/BannerDetails.vue"
export default component.exports